










import { computed, defineComponent } from "@vue/composition-api";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import { formatMoneyString } from "@/lib/moneyHelpers";
import { ListFields } from "@/types";
import BaseSelect from "@/components/BaseSelect";

export default defineComponent({
  name: "AttachmentPriceSetting",
  components: { BaseSelect },
  props: {
    packageList: { type: Array as () => PaymentPackage[], required: true },
    attachmentPriceId: { type: String, required: true },
  },
  setup(props) {
    const { authorities } = useAuthUser();
    const allowSetPrice = computed(() => checkAuthorities(authorities.value, ["updateMyContentPrice"]));

    const packageOptions = computed<ListFields>(() => {
      return props.packageList.reduce(
        (out, packageData) => {
          out.push({
            text: formatMoneyString(packageData.amount),
            value: packageData.id,
          });
          return out;
        },
        [{ text: $t("Free"), value: "0" }]
      );
    });

    return {
      packageOptions,
      allowSetPrice,
    };
  },
});
